export default {
    hasPendingInvoices: undefined,
    educationalVideos: {},
    snackBarData: { message: '', bgColor: 'success' },
    stopFillingPlannings: false,
    plannerLogin: {
        clients: [],
        plannerLoginData: null,
        credentials: null,
    },
}
